import React from 'react';
import { ContainerGeral, ContTwoGraph, Refresh } from './styles';
import Semaphore from './components/Semaphore';
import KPI from './components/KPI';
import MeterGaugePlot from './components/MeterGaugePlot';
import Filter from './components/Filter';
import MultipleLine from './components/MultipleLine';
import Donut from './components/Donut';
import BasicColumn from './components/BasicColum';
import Stacked from './components/Stacked';
import { useWindowSize } from '../../../hook/useWindowSize';
import { Button, Result } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import { loadRequest as loadSemaphore } from '../../../store/ducks/semaphore/actions';
import { dashSlaRequest } from '../../../store/ducks/dashSlaAtendimento/actions';
import { loadRequest as loadkpiAC } from '../../../store/ducks/kpiAC/actions';
import { loadRequest as loadkpiSA } from '../../../store/ducks/kpiSA/actions';
import { loadRequest as loadkpiSE } from '../../../store/ducks/kpiSE/actions';
import { loadRequest as loadkpiEAI } from '../../../store/ducks/kpiEAI/actions';
import { loadRequest as loadkpiEAE } from '../../../store/ducks/kpiEAE/actions';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../../store';
import moment from 'moment';

const Dashboard: React.FC = () => {
  const { width }: any = useWindowSize();
  const dispatch = useDispatch();
  const cd = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd) as number;
  const inscricoes = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);

  React.useEffect(() => {
    dispatch(dashSlaRequest(moment().format(), moment().format(), cd, inscricoes));
    const array = document.querySelectorAll('.itens');
    localStorage.setItem('filterDashboard', moment().format());
    array.forEach((item) => {
      item?.classList?.remove('active');
      if (item?.innerHTML === 'Dia') item?.classList.add('active');
    });
  }, [dispatch, cd, inscricoes]);

  const handleRefresh = () => {
    const dataSelecionada = localStorage.getItem('filterDashboard');
    const dateKpiAC = localStorage.getItem('filterkpiAC');
    const dateKpiSA = localStorage.getItem('filterkpiSA');
    const dateKpiSE = localStorage.getItem('filterkpiSE');

    dataSelecionada && dispatch(dashSlaRequest(dataSelecionada, moment().format(), cd, inscricoes));
    dateKpiAC && dispatch(loadkpiAC(cd, inscricoes, dateKpiAC, 'AC', 1));
    dateKpiSA && dispatch(loadkpiSA(cd, inscricoes, dateKpiSA, 'SA', 1));
    dateKpiSE && dispatch(loadkpiSE(cd, inscricoes, dateKpiSE, 'SE', 1));
    dispatch(loadkpiEAI(cd, inscricoes, 'EAI', 1));
    dispatch(loadkpiEAE(cd, inscricoes, 'EAE', 1));
    dispatch(loadSemaphore(cd, inscricoes));
  };
  return width > 768 ? (
    <>
      <Refresh onClick={() => handleRefresh()}>
        <RedoOutlined className="icon" />
        <div className="themeDashboard" style={{ background: 'none' }}>
          Atualizar
        </div>
      </Refresh>

      <ContainerGeral>
        <div className="filter">
          <Filter />
        </div>

        <div className="semaphoreComponent themeSLA">
          <Semaphore />
        </div>

        <div className="kpiComponent">
          <KPI />
        </div>

        <ContTwoGraph>
          <div className="graph meterComponent themeSLA">
            <MeterGaugePlot />
          </div>

          <div className="graph multipleLine themeSLA">
            <MultipleLine />
          </div>
        </ContTwoGraph>

        <ContTwoGraph>
          <div className="graph donut themeSLA">
            <Donut />
          </div>

          <div className="graph basicColumn themeSLA">
            <BasicColumn />
          </div>
        </ContTwoGraph>

        <div className="graph stacked themeSLA">
          <Stacked />
        </div>
      </ContainerGeral>
    </>
  ) : (
    <>
      <Result
        status="500"
        title="Em desenvolvimento"
        subTitle="Desculpe, essa página ainda não está disponível na versão mobile."
        extra={
          <Button onClick={() => window.history.back()} type="primary">
            Voltar
          </Button>
        }
      />
    </>
  );
};
export default Dashboard;
